import LocationShow from './LocationShow'
export {LocationShow}
export default LocationShow
